import { useAppShellChat } from '@/features/chat/useAppShellChat'
import { useAppShellLayoutHandlers } from './useAppShellLayoutHandlers.js'
import { buildAppShellSecondaryNavProps, resolveAppShellHomeNav } from './buildAppShellSecondaryNavProps.js'
import { useAppShellLayoutReturn } from './useAppShellLayoutReturn.js'

export function useAppShellLayout() {
  const chat = useAppShellChat()
  const handlers = useAppShellLayoutHandlers({
    location: chat.location,
    navigate: chat.navigate,
    setSelectedThreadId: chat.setSelectedThreadId,
    setHomeView: chat.setHomeView,
  })
  const homeNav = resolveAppShellHomeNav({
    activePrimaryKey: chat.activePrimaryKey,
    threads: chat.threads,
    pinnedThreadIdsForNav: chat.pinnedThreadIdsForNav,
  })
  const secondaryNavProps = buildAppShellSecondaryNavProps({
    chat,
    handlers,
    ...homeNav,
  })
  return useAppShellLayoutReturn({
    chat,
    handlers,
    secondaryNavProps,
  })
}
